import { render, staticRenderFns } from "./BoxCom.vue?vue&type=template&id=47cb5e2d&"
import script from "./BoxCom.vue?vue&type=script&lang=ts&"
export * from "./BoxCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports